import { render, staticRenderFns } from "./ScopesDialog.vue?vue&type=template&id=4ab4d36a&scoped=true"
import script from "./ScopesDialog.vue?vue&type=script&lang=js"
export * from "./ScopesDialog.vue?vue&type=script&lang=js"
import style0 from "./ScopesDialog.vue?vue&type=style&index=0&id=4ab4d36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab4d36a",
  null
  
)

export default component.exports